__turbopack_context__.v({
  "shimmer": "Skeleton-module-scss-module__g3_rIG__shimmer",
  "skeleton": "Skeleton-module-scss-module__g3_rIG__skeleton",
});
